"use client";

const HOME_SESSION_ID_KEY = "sr_home_session_id";

export function getOrCreateHomeSessionId(): string {
  if (typeof window === "undefined") return "";
  let id = sessionStorage.getItem(HOME_SESSION_ID_KEY);
  if (!id) {
    id = `h_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(HOME_SESSION_ID_KEY, id);
  }
  return id;
}
